
import { VTextField } from 'vuetify/lib';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
@Component({ name: 'd4y-text-field' })
export default class D4yTextField extends VTextField {
  @Prop({ default: false })
  rounded!: boolean;
  @Prop({ default: true })
  outlined!: boolean;
  @Prop({ default: true })
  dense!: boolean;
}
